module.exports = __webpack_public_path__ + "static/media/butt05.981b3894.png";